module.exports = __webpack_public_path__ + "img/pencil-no-shadow-alt.a7bee64.png";